export const WarningIcon = () => {
  return (
    <svg
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.302246"
        y="0.722168"
        width="68.115"
        height="68.115"
        rx="34.0575"
        fill="#FDF4F4"
      />
      <circle cx="34.5322" cy="34.7797" r="27.0375" fill="#FCEEEE" />
      <circle
        cx="34.532"
        cy="40.45"
        r="1.13403"
        transform="rotate(-180 34.532 40.45)"
        fill="#B22234"
      />
      <path
        d="M34.532 37.0478L34.532 29.1096M45.8723 34.7798C45.8723 41.0429 40.7951 46.1201 34.532 46.1201C28.2689 46.1201 23.1917 41.0429 23.1917 34.7798C23.1917 28.5167 28.2689 23.4395 34.532 23.4395C40.7951 23.4395 45.8723 28.5167 45.8723 34.7798Z"
        stroke="#B22234"
        strokeWidth="1.70105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
